import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.user-labels.copy', {
        url: '/copy',
        params: {users: [],labels:[]},
        views: {
            '@company': 'companyUserLabelMembersCopy'
        },
        resolve: {
            users,labels,userLabelId
        },
    });
}

/** @ngInject */
function users($stateParams) {
    return $stateParams.users;
}
/** @ngInject */
function labels($stateParams) {
    return $stateParams.labels;
}

function userLabelId($stateParams) {
    return $stateParams.userLabelId;
}




// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/copy/copy-users-to-labels.state.js